import React from 'react'
import { Link2 } from '../../link/link.jsx'
import { isLocal } from '../../../utility'
import { convertToPascalCase } from '../../utilities/utilities.js'
import { getTitle } from './blogFilterDeepLinksUtilities'

function BlogFilterDeepLinks({ data = [] }) {
  return (
    <div className="BlogFilterDeepLinks">
      {data.map((item) => (
        <div
          className="u-flex u-flexAlignItemsCenter u-sm-marginBottom4gu"
          key={item?.key}
        >
          <div className="u-flex">
            <div className="u-textSecondary u-textBold">
              {getTitle(item?.key)}:
            </div>
            <div className="u-flex u-marginLeft2gu u-textColorBrandLight u-md-textSizeMsrm1 u-textItalic u-textCapitalize">
              {item?.categories.map((category, index) => (
                <React.Fragment key={category?.key}>
                  {index > 0 && <span>,&nbsp;</span>}
                  <Link2
                    className="Link u-flex u-textItalic"
                    url={
                      isLocal()
                        ? `/site/blogspa?topic=${category?.key}`
                        : `/insights/latest-insights?topic=${category?.key}`
                    }
                    text={convertToPascalCase(
                      category?.key?.replaceAll('-', ' ')
                    )}
                  />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export { BlogFilterDeepLinks }
